import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { ColleaguesModule } from '@app/components/colleagues/colleagues.component';
import { MyCollaborationActivitiesModule } from '@app/components/my-collaboration-activities/my-collaboration-activities-widget/my-collaboration-activities-widget.component';
import { MyLatestSitesModule } from '@app/components/my-latest-sites/my-latest-sites.component';
import { SiteIndexModule } from '@app/components/site-index/site-index.component';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-collaboration',
  templateUrl: './collaboration.component.html',
  styleUrls: ['./collaboration.component.scss']
})
export class CollaborationComponent { }
@NgModule({
  declarations: [CollaborationComponent],
  exports: [CollaborationComponent],
  imports: [
    CommonModule,
    LinkModule,
    MyCollaborationActivitiesModule,
    MyLatestSitesModule,
    ColleaguesModule,
    SiteIndexModule,
  ]
})
export class CollaborationModule { }
